<script>
import { authComputed, authMethods } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import hkService from "@/helpers/APIService/hk.service";

export default {
  name: "Mini_Bar",
  props: {
    currentProps: Object,
  },
  data() {
    return {
      isError: false,
      errorMessage: "",
      stocks: [],
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getMinibarStock();
  },

  methods: {
    ...authMethods,
    async getMinibarStock() {
      try {
        const miniBarStock = await hkService.getMiniBarItemStock(
          this.currentProps.selectedRoom
        );
        this.stocks = miniBarStock;
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is for decrease a mini bar item stock
    decreaseValue(item) {
      if (item.stock !== 0) {
        item.stock -= 1;
        hkService
          .updateMiniBarItemStock(this.currentProps.selectedRoom, item.id, {
            stock: item.stock,
          })
          .then((response) => {
            // this.stocks = response;
            Middleware.notification(
              "Stock decreased successfully !!",
              "success"
            );

            this.isError = false;
            this.errorMessage = "";
          })
          .catch((error) => {
            this.isError = true;
            errorHandler(error);
          });
      } else {
        item.stock = 0;
      }
    },
    // Method is for increase a mini bar item stock
    increaseValue(item) {
      item.stock += 1;
      hkService
        .updateMiniBarItemStock(this.currentProps.selectedRoom, item.id, {
          stock: item.stock,
        })
        .then((response) => {
          // this.stocks = response;
          Middleware.notification("Stock increased successfully !!", "success");

          this.isError = false;
          this.errorMessage = "";
        })
        .catch((error) => {
          this.isError = true;
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Mini Bar Item Stock</h4>
        <hr />
      </div>
    </div>
    <div class="row">
      <p class="text-blue my-1" slot="header"></p>
      <div class="col-md-4" v-for="(item, index) in stocks" :key="index">
        <b-card>
          <img
            class="w-100 stock-img"
            alt="Card image cap"
            :src="
              item.mini_bar_item.image !== null
                ? item.mini_bar_item.image
                : 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22286%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20286%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_17fe3c2fb9a%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A14pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_17fe3c2fb9a%22%3E%3Crect%20width%3D%22286%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2299.12312316894531%22%20y%3D%2296.3%22%3EImage%20cap%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E'
            "
          />
          <div class="row mt-2 mb-1">
            <div class="col-6">
              <span class="text-dark">
                <b>Name</b> :
                <span class="d-block">
                  {{ item.mini_bar_item.name }}
                </span></span
              >
            </div>
            <div class="col-6 text-end">
              <span class="text-dark"
                ><b>Price</b> :
                <span class="d-block">{{
                  item.mini_bar_item.price
                }}</span></span
              >
            </div>
          </div>
          <div class="d-flex">
            <button class="btn btn-primary me-2" @click="decreaseValue(item)">
              -
            </button>
            <b-form-input
              id="name-input"
              v-model="item.stock"
              type="number"
              autocomplete="off"
            ></b-form-input>
            <button class="btn btn-primary ms-2" @click="increaseValue(item)">
              +
            </button>
          </div>
        </b-card>
      </div>
      <div v-if="stocks.length == 0">
        <b-card>
          <div class="row">
            <div class="col-md-12 text-center">
              <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
              <p>
                <span class="text-secondary">No Data Found</span>
              </p>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<style scoped>
.stock-img {
  height: 200px;
  object-fit: cover;
}
</style>
